import { createContext, useContext, useState } from 'react';

export type EnhancementMeta = {
  id: string;
  bookId: string;
  title: string;
  attribution: {
    curator: {
      id: string;
      displayName: string;
    },
    publisher?: {
      id: string;
      displayName: string;
    }
  };
  ratings?: {
    score: number;
    count: number;
  };
  price?: number;
  imageUrl: string;
  enhancementType: {
    notes?: boolean,
    illustrations?: boolean,
    discussion?: boolean,
    glossary?: boolean
  }
  owned: boolean;
};

type EnhancementLibraryContextType = {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  enhancementsInCollection: EnhancementMeta[];
  enhancementsFromStore: EnhancementMeta[];
};

const EnhancementLibraryContext = createContext<EnhancementLibraryContextType>({
  searchTerm: '',
  setSearchTerm: () => {},
  enhancementsInCollection: [],
  enhancementsFromStore: []
});

const nealImage = require('../../../../library/neal.jpeg'); // eslint-disable-line @typescript-eslint/no-var-requires
const hupImage = require('../../../../library/covers/hup-image.jpeg'); // eslint-disable-line @typescript-eslint/no-var-requires
const penguinImage = require('../../../../library/covers/penguin-image.jpeg'); // eslint-disable-line @typescript-eslint/no-var-requires

const NEALS_ENHANCEMENT: EnhancementMeta = {
  id: '1',
  title: 'Neal\'s Notes',
  bookId: '1',
  attribution: {
    curator: {
      id: '1',
      displayName: 'Neal Williams',
    }
  },
  imageUrl: nealImage,
  enhancementType: {
    illustrations: true,
    notes: true,
    discussion: true,
    glossary: true
  },
  owned: true
}

const HUP_ENHANCEMENT: EnhancementMeta = {
  id: '2',
  title: 'An Annotated Edition',
  bookId: '1',
  attribution: {
    curator: {
      id: '2',
      displayName: 'Patricia Meyer Spacks',
    },
    publisher: {
      id: '2',
      displayName: 'Harvard University Press'
    }
  },
  ratings: {
    score: 5,
    count: 47 
  },
  imageUrl: hupImage,
  enhancementType: {
    illustrations: true,
    notes: true,
  },
  owned: true
};


const PENGUIN_ENHANCEMENT: EnhancementMeta = {
  id: '3',
  title: 'The Annotated Pride & Prejudice',
  bookId: '1',
  attribution: {
    curator: {
      id: '3',
      displayName: 'David M. Shapard',
    },
    publisher: {
      id: '3',
      displayName: 'Penguin Random House'
    }
  },
  imageUrl: penguinImage,
  enhancementType: {
    illustrations: true,
    notes: true,
  },
  ratings: {
    score: 5,
    count: 65
  },
  owned: false
};

export const EnhancementLibraryProvider: React.FC = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const enhancementsFromStore: EnhancementMeta[] = [
    PENGUIN_ENHANCEMENT,
    HUP_ENHANCEMENT,
    NEALS_ENHANCEMENT,

  ];
  const enhancementsInCollection: EnhancementMeta[] = [
    NEALS_ENHANCEMENT,
    HUP_ENHANCEMENT,
  ];

  return (
    <EnhancementLibraryContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        enhancementsFromStore,
        enhancementsInCollection
      }}
    >
      {children}
    </EnhancementLibraryContext.Provider>
  );
};

export const useEnhancementLibrary = () => useContext(EnhancementLibraryContext);
